<template>
	<div class="fileinput w-100">
		<div  class="smth" v-if="type=='file'">
			<form :id="formId" :name="formId" enctype="multipart/form-data">
				<label class="" v-if="typeof additionalInfo !='undefined' && additionalInfo !=''"> <i class="tim-icons text-danger icon-alert-circle-exc mr-2" style="font-size: 16px;"></i>{{ additionalInfo }}</label>
				<label class="mr-2 d-flex align-items-center" v-if="typeof help !='undefined' && help !=''">
					<el-popover
					placement="bottom"
					title="Как заказать выписку на Госуслугах"
					width="350"
					trigger="hover"
					content="">
					<template v-slot:reference>
						<i class="tim-ic ic-question text-primary mr-2" style="font-size: 16px;"></i>
					</template>
					<div class="btnovertext">{{ help }}</div>
					</el-popover>
					Как заказать выписку на Госуслугах 
				</label>
				
				<div :class="btnClass.btn" class="btn-file m-0 mr-2 smth-span" v-if="!fileExists || multiple">
					<i :class="btnClass.icon"></i>
					<input
						:accept="acceptMime"
						@change="handlePreview"
						type="file"
						name="in_files"
						ref="in_files"
						class="valid smth-input"
						:multiple="multiple"
						aria-invalid="false"
					/>
				</div>

				<div v-if="fileExists && bShowTrash" :class="[{ 'd-none': multiple == false }, { 'd-inline-block': multiple == true }]" class="" >
					<button class="btn btn-icon btn-simple btn-danger m-0"  v-on:click.prevent.stop="removeFile">
						<i class="tim-icons icon-trash-simple"></i>
					</button>
					<div class="filesCount">{{ imagePreview }}</div>
				</div>
				<!-- <div v-if="fileExists && bShowTrash" class="d-inline-block">
					<button class="btn btn-simple btn-primary my-0 ml-2" v-on:click.prevent.stop="ShowSort()">
						Сортировать
					</button>
				</div> -->
				
				<!-- <el-carousel v-if="fileExists && bShowTrash" height="200px" :autoplay="false" arrow="always" indicator-position="none">
					<el-carousel-item v-for="(imgSrc,idx) in masPhotos" :key="idx" >
						<button class="btn-rotateitem btn btn-icon btn-simple btn-success m-0" v-on:click.prevent.stop="rotateCurrentFile(idx)" style="z-index:100">
							<i class="tim-icons icon-refresh-01"></i>
						</button>
						<button class="btn-removeitem btn btn-icon btn-simple btn-danger m-0" v-on:click.prevent.stop="removeCurrentFile(idx)" style="z-index:100">
							<i class="tim-icons icon-simple-remove"></i>
						</button>
						<a :href="imgDocSrc(idx)" target="_blank" class="d-block">
							<div class="imgPreview" @click="onImgClick(imgSrc)">
								<img :src="imgSrc" alt="preview" :style="{transform: `rotate(${objImgDeg[imgSrc]}deg)`}">
							</div>
						</a>
					</el-carousel-item>
				</el-carousel> -->
				
				<!-- <div v-show="bShowSorting">not hehe</div> -->

				<div class="files-container" v-if="fileExists && bShowTrash && bShowDraggable">
					<p class="py-2" v-if="multiple == true"><i class="tim-icons text-primary icon-alert-circle-exc mr-1"></i> Для изменения порядка фотографии перетащите её на нужную позицию.</p>
					<div class="" :class="[{ 'fastScrollContainer': multiple == true}]">
					<div :class="[{ 'filesContainerSingle': multiple == false }, { 'filesContainer': multiple == true }]">
						<div class="fastScrollSpot" v-if="(multiple == true) || (multiple == false && value < 1)"><span class="text-success">Точка быстрого скролла</span></div>
							<draggable
								class="list-group"
								tag="ul"
								:list="value"
								:disabled="enabled"
								handle=".handle"
								ghostClass="ghost"
								v-bind="dragOptions"
								@start="drag = true"
								@end="drag = false"
								
							>
							<!-- <draggable
								class="list-group"
								tag="ul"
								:list="value"
								:disabled="!enabled"
								handle=".handle"
								ghostClass="ghost"
								
								@start="drag = true"
								@end="drag = false"
								
							> -->
								<li class="fileItem mb-2 list-group-item handle-old" v-for="(imgSrc,idx) in masPhotos" :key="`${idx}-${imgSrc}`" 
									>
								<!-- <li class="fileItem mb-2 list-group-item" v-for="(imgSrc,idx) in value" :key="idx"> -->
									<div class="mb-2 d-flex" >
										<!-- <span class="btn-handle btn-icon btn-simple btn-primary mr-3 px-3 " v-if="multiple == true">
											<i class="tim-icons icon-tap-02 text-primary" style="font-size: 26px;"></i>
										</span> -->
										<div class="px-0 handle">
											<div class="fileItemContainer">
												<a :href="imgDocSrc(idx)" target="_blank" class="d-block">
													<div class="itemPhoto mr-2" @click="onImgClick(imgSrc)">
														<img :src="canRotate(imgSrc)?imgSrc:'/img/uploadicon.svg'" :id="idx" alt="preview" :style="{transform: `rotate(${objImgDeg[imgSrc]}deg)`}" style="transition:0.3s;"/>
														<span class="itemPhotoPos">{{idx+1}}</span>
													</div>
												</a>

												<el-popover
													v-if="uploadApi.apiParam.flt.type == 'mo_photos'"
													placement="right"
													:title="objImgOrigFn[imgSrc]"
													width="350"
													height="350"
													trigger="hover"
													>
													<template v-slot:reference>
														<!-- <base-button class="btn btn-icon no-border btn-simple btn-primary my-0 ml-2 btn-watch-icon"><i class="tim-ic ic-eye"></i></base-button> -->
														<i class="tim-icons icon-zoom-split text-primary zoomhover mr-2" style="font-size: 26px;"></i>
													</template>
													<template v-slot:default>
														<div class="" style="width:325px; height: 325px;">
															<img :src="imgSrc" :id="idx" alt="preview" :style="{transform: `rotate(${objImgDeg[imgSrc]}deg)`}" style="transition:0.3s;width:100%; height: 100%; object-fit: cover;">
															<!-- <ReLeadStaffInfo :objData="getObjects"  /> -->
															<!-- <ReLeadStaffInfo :objData="leadStaffInfo" :lead_id="ApiData.id" /> -->
														</div>
													</template>
													
												</el-popover>
											</div>
										</div>
										<div class="handle" style="width: 100%;">
											<p class="itemTitle" v-if="isImg(imgDocSrc(idx))">{{getTitle(objImgOrigFn[imgSrc])}}</p>
											<p class="itemTitle" v-else>{{src_filenames[idx]}}</p>
										</div>
										

										<div class="px-0">
											<div class="d-flex justify-content-end">	
												<div  class="btn btn-icon btn-simple btn-success my-0 mr-1" v-if="bshowClipboard && imgSrc!=''">
													<ReCopyClipboard :value="imgSrc" imgClipboard />		
												</div>
												<button v-if="canRotate(imgSrc)" class="btn btn-icon btn-simple btn-success my-0 mr-1" v-on:click.prevent.stop="rotateCurrentFile(idx)" style="z-index:100 !important">
													<i class="tim-icons icon-refresh-01"></i>
												</button>
												<button class="btn btn-icon btn-simple btn-danger m-0" v-on:click.prevent.stop="removeCurrentFile(idx)" style="z-index:100 !important">
													<i class="tim-icons icon-simple-remove"></i>
												</button>
											</div>
										</div>
									</div>
									<!-- <span>{{getIntrinsicSize(idx)}}</span> -->
									<!-- <p class="itemTitle д">{{imgSrc.naturalHeight}}</p> -->
								</li>
							</draggable>
						</div>
					</div>
				</div>

			</form>
		</div>
		<!-- <div v-if="type=='video'">
			<form :id="formId" :name="formId" enctype="multipart/form-data">

			</form>
		</div> -->
		<div v-else style="text-align: center;">
			<form :id="formId" :name="formId" enctype="multipart/form-data">
				<div class="fileinput-new thumbnail " :class="[{ 'img-circle': type === 'avatar' }, { 'img-circle': type === 'file' }]">
					<img :src="image" alt="preview" />
				</div>
				<div>
					<span class="btn btn-primary btn-simple btn-file">
						<span class="fileinput-new">
							{{
							fileExists ? changeText : selectText
							}}
						</span>
						<input type="hidden" value name />
						<input
							accept="image/*"
							@change="handlePreview"
							type="file"
							name="in_files"
							class="valid"
							:multiple="multiple"
							aria-invalid="false"
						/>
					</span>
					<base-button v-if="fileExists" @click="removeFile" simple type="danger">
						<i class="fas fa-times"></i>
						{{ removeText }}
					</base-button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { Carousel, CarouselItem, Input, Popover } from "element-ui";
import draggable from 'vuedraggable';
import ReCopyClipboard from 'src/our_components/ReCopyClipboard.vue';


export default {
	name: "ReFileUpload",
	components: {
		[Carousel.name]: Carousel,
		[CarouselItem.name]: CarouselItem,
		[Input.name]: Input,
		[Popover.name]: Popover,
		draggable,
		ReCopyClipboard,
	},
	props: {
		value: {
			type: [String, Array],
			default: "",
			description: "Initial image to display"
		},
		src_filenames: {
			type: Array,
			default: function() {
				return [];
			},
			description: "Initial src_filenames image to display"
		},
		uploadApi: {
			type: Object,
			default: function() {
				return {};
			}
		},
		findId: {
			type: String,
			default: ""
		},
		delApi: {
			type: Object,
			default: function() {
				return {};
			}
		},
		strFilePath: {
			type: String,
			default: "",
			description: 'Путь до файла'
		},
		type: {
			type: String,
			default: "",
			description: 'Image upload type (""|avatar|file|video)'
		},
		src: {
			type: String,
			default: "",
			description: "Initial image to display"
		},
		selectText: {
			type: String,
			default: "Выбрать"
		},
		changeText: {
			type: String,
			default: "Изменить"
		},
		removeText: {
			type: String,
			default: "Удалить"
		},
		multiple: {
			type: Boolean,
			default: false
		},
		formId: {
			type: String,
			default: "uploadForm"
		},
		btnClass: {
			type: Object,
			default: function() {
				return {
					btn: "btn btn-icon btn-simple btn-success",
					icon: "tim-icons icon-attach-87"
				};
			}
		},
		bShowTrash: {
			type: Boolean,
			default: true
		},
		acceptMime: {
			type: String,
			default: "*/*"
		},
		bShowDraggable: {
			type: Boolean,
			default: true
		},
		bshowClipboard: {
			type: Boolean,
			default: false
		},
		additionalInfo: {
			type: String,
			default: "",
		},
		help: {
			type: String,
			default: "",
		},
	},
	data() {
		let avatarPlaceholder = "/img/placeholder.jpg";
		let imgPlaceholder = "/img/uploadicon.svg";
		return {
			placeholder: this.type === "avatar" ? avatarPlaceholder : imgPlaceholder,
			imagePreview: null,
			masImgExtansions:['bmp','tiff','jpeg','jpg','gif','png', 'pdf', 'JPG'],
			objImgDeg: {},
			objImgOrigFn: {},
			bShowSorting:false,
			// enabled: true,
			// fullscreenLoading: false,
		};
	},
	watch: {
		value(val){
			if(this.value instanceof Array && this.type === "file"){
				if(this.value.length > 0 ) this.imagePreview = this.value.length;
			} else {
				if(this.value.length > 0 ) this.imagePreview = this.value[this.value.length - 1];
			}
			
		}
	},
	computed: {
		fileExists() {
			return (
				this.value !== null &&
				this.value != "" &&
				this.value != "/img/placeholder.jpg" &&
				this.value != "/img/uploadicon.svg"
			);
		},
		image() {
			return this.imagePreview || this.value || this.src || this.placeholder;
		},
		masPhotos(){
			//console.log('masPhotos', this.objImgDeg);
			let masRet = [];
			//this.objImgDeg = {};
			this.objImgOrigFn = {};

			for (let i = 0; i < this.value.length; i++) {
				if(this.isImg(this.value[i])){
					// console.log('this.value[i]',this.value[i].substring(this.value[i].lastIndexOf('/') + 1));
					masRet.push(this.value[i]);
					if(!this.objImgDeg.hasOwnProperty(this.$GVO.unlinkObject(this.value[i]))){
						this.$set(this.objImgDeg, this.$GVO.unlinkObject(this.value[i]), 0);
					}
					let strFN = this.value[i].substring(this.value[i].lastIndexOf('/') + 1);
					// console.log('strFN',strFN);
					if(typeof this.src_filenames[i] !='undefined')strFN = this.src_filenames[i];
					//console.log('strFN2',strFN);
					this.$set(this.objImgOrigFn, this.$GVO.unlinkObject(this.value[i]), strFN);
					
				}else{
					masRet.push('/img/uploadicon.svg');
				}
			}
			return masRet
		},
		dragOptions() {
			return {
				animation: 200,
				group: "description",
				disabled: false,
				ghostClass: "ghost"
			};
		},
		enabled(){
			if(this.multiple == true ){
				return false;
			} 
			// else if (this.multiple == false && (this.value == '' || this.value < 1 )){
			// 	return false;
			// } 
			else {return true;}
		}
	},
	methods: {
		getTitle(name){
			return String(name).split('?')[0];
		},
		canRotate(name){
			return name.match(/\.(jpe?g|png|gif|bmp|tiff?)(\?.*)?$/i)
		},
		onImgClick(strImgPath){
			// console.log(strImgPath);
		},
		isImg(strFileName){
			const masFile = strFileName.split('.');
			if(masFile.length > 0){
				const ext = masFile[masFile.length-1].split('?')[0];
				if(this.masImgExtansions.indexOf(ext.toLowerCase()) != -1) return true;
			}
			return false;
		},
		imgDocSrc(idx){
			return this.value[idx];
		},
		handlePreview(event) {
			//console.log('handlePreview',event.target.files);
			let files = event.target.files;
			// let strnaturalHeight = files.naturalHeight ;
			// console.log('strnaturalHeight',strnaturalHeight);
			// console.log('handlePreview',files);
			if (this.type != "file") {
				this.imagePreview = URL.createObjectURL(files[0]);
			} else {
				if (files.length > 0) {
					this.imagePreview = files.length;
				}
			}
			//console.log('koko ',files);
			this.$emit("change", {
				files: files,
				formId: this.formId,
				selfObj: this
			});
		},
		removeFile() {
			if (!this.$GVO.isEmpty(this.delApi)) {
				this.$GVO
					.ApiCall(this.delApi.apiMethod, this.delApi.apiParam)
					.then(objApi => {
						// console.log(objApi);
						if (objApi.success === true) {
							this.imagePreview = null;
							// this.imagePreview = '/img/placeholder.jpg';
							this.$emit("change", this.findId);
						}
					})
					.catch(errorObjApi => {
						console.error(errorObjApi);
						this.bIsLoading = false;
					});
			} else {
				// this.imagePreview = null;
				//this.$emit("change", this.findId);
				//this.value = [];
				this.$emit("clear", this.findId);
				//console.log('clear');
			}
		},
		removeCurrentFile(idx){
			this.$emit('removeFile',idx, this.value[idx]);
			const remImg = this.value.splice(idx, 1);
			this.$refs.in_files.value = null;
			/*
			if(typeof this.objImgDeg[remImg[0]] != 'undefined'){
				delete this.objImgDeg[remImg[0]];
			}
			*/
			if(this.value.length==0){
				this.imagePreview = null;
				// this.imagePreview = '/img/placeholder.jpg';
				//console.log(this.findId);
				this.$emit("change", this.findId);
			}
		},
		rotateCurrentFile(idx){
			let strFizFile = this.value[idx];
			// console.log(strFizFile);
			this.objImgDeg[strFizFile] += 90;

			this.$GVO.ApiCall('FileUpload.RotateImage',{flt:{'strImgPath':strFizFile}})
			.then((objApi) => {
				if(objApi.success === true){
					// this.objImgDeg[idx] += 90;
				}
			}).catch(errorObjApi => console.error(errorObjApi));
			// this.value[idx] = this.objImgDeg[strFizFile];
			// this.$emit("change", this.value[idx]);
		},
		ShowSort(){
			this.bShowSorting = !this.bShowSorting;
		},
		// openFullScreen1() {
		// 	this.fullscreenLoading = true;
		// 	setTimeout(() => {
		// 	this.fullscreenLoading = false;
		// 	}, 3000);
		// },
		// getIntrinsicSize(idx){
		// 	//return this.value[idx];
		// 	let imgData = document.getElementById(idx);
		// 	// let imgDataInObj = {naturalHeight:imgData.naturalHeight, naturalWidth:mgData.naturalWidth};
		// 	console.log('naturalHeight and naturalWidth ', imgData.naturalHeight);
		// 	// return imgData;
		// 	// console.log('naturalHeight and naturalWidth ', imgData.naturalHeight, imgData.naturalWidth);
		// }, 
		// drop(e){
		// 	const item_id = e.dataTransfer.getData('item_id');
		// 	const item = document.getElementById(item_id);
		// 	item.style.display = "flex";
		// 	e.target.appendChild(item);
		// },
		// dragStart(e){
		// 	const target = e.target;
		// 	e.dataTransfer.setData('item_id', target.id);
		// 	// console.log(target.id);
		// 	setTimeout(()=> {
		// 		target.style.display = "none";
		// 	},0);
		// }
	},
	mounted(){
		if(this.value instanceof Array){
			if(this.value.length > 0 ) this.imagePreview = this.value.length;
		}
	}
};
</script>
<style>
.fileinput {
	vertical-align: top;
}
.filesCount {
	position: absolute;
	color: white;
	margin-top: -50px;
	margin-left: 35px;
	background-color: red;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	text-align: center;
}

.fileinput .thumbnail > img {
	width: 100px;
	height: 100px;
	object-fit: contain;
}

.fileinput .el-carousel{
	width: 250px;
	margin-top: 10px;
}
.fileinput .el-carousel .imgPreview{
	display: flex;
	justify-content: space-around;
}
.fileinput .el-carousel .imgPreview > img {
	height: 200px;
	object-fit: cover;
}

.btn-removeitem{
	position: absolute !important;
    right: 0px;
	/* background: rgba(31,45,61,.85) !important; */
}
.btn-rotateitem{
	position: absolute !important;
    right: 40px;
	/* background: #fff!important; */
	/* background: rgba(31,45,61,.85) !important; */
}
.btn-down{
	position: absolute !important;
    right: 80px;
}
.btn-top{
	position: absolute !important;
    right: 120px;
}

.filesContainer {
	padding: 0px 10px 0px 0px;
	height: 350px;
	width: 100%;	
	/* background: rgb(180, 196, 247); */
	overflow-y: scroll;	
	
}

.filesContainerSingle {
	/* padding: 10px; */
	/* height: 350px; */
	width: 100%;	
	/* background: rgb(180, 196, 247); */
	/* overflow-y: scroll;	 */
}
.fileItem {
	padding: 10px;
	border: 1px solid #9e77f3;
	border-radius: 0.2857rem;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	background-color: inherit;
}
.fileItemContainer {
	display: flex;
}
.itemPhoto {
	display: flex;
    width: 60px;
    height: 60px;
	position: relative;
}
.itemPhoto img{
    width: 100%;
    height: 100%;
    margin: 0 auto;
    object-fit: cover;
}
.itemPhotoPos {
	position: absolute;
	bottom: -4px;
	right: -4px;
	background: #01B0E0;
	border-radius: 50%;
	height: 20px;
    width: 20px;
    color: #fff;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
}
.itemTitle {
	/* max-width: 250px; */
	width: 100%;
    word-break: break-word;
	/* display: none; */
}

.list-group-item + .list-group-item {
    border-top-width: thin!important;
}

.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

.btn-handle{
	border-radius: 0.4285rem;
	display: flex;
    align-items: center;
	cursor: pointer;
}
.fastScrollContainer {position: relative;}
.fastScrollSpot {
	width: 250px; height: 20px; 
	display: none; 
	justify-content: center; 
	position: absolute; 
	top:0; 
	left: calc(50% - 125px); 
	border-radius: 0 0 0.4285rem 0.4285rem;
	border-left: 1px solid #00BF9A; 
	border-right: 1px solid #00BF9A; 
	border-bottom: 1px solid #00BF9A; 
	z-index: 1000;
}
.btnovertext {white-space: pre-wrap!important; word-break: break-word!important;}
/* .itemTitle{color: black !important;} */
/* .zoomhover:hover {

} */
/* .fileItemContainer {position: relative;}
.itemPhoto:hover {width: 250px; height: 250px; position: relative; z-index: 100;} */

/* .btn-rotateitem-container .btn-rotateitem .white-content .btn:not([data-action]) {background: #fff!important;}
.btn-rotateitem-container .btn-rotateitem .white-content .btn:not([data-action]):hover {background: #fff!important;} */

/*я задолбалась искать, почему кнопка не cursor: pointer
.fileinput:hover, .fileinput span:hover, .fileinput form:hover, .icon-attach-87:hover, .fileinput input:hover, .smth:hover, .smth input:hover, .smth span:hover, .smth-input:hover {cursor: pointer;}
*/

/* .el-carousel__indicators {display: none;} */

@media (max-width: 370px){
	.fileinput .el-carousel {
		width: 200px;
	}
}
@media (max-width: 786px){
	.filesContainer {
		padding: 0px 30px 0px 0px;
	}
}
@media (max-width: 460px){
	/* .fileItemContainer {
		flex-wrap: wrap;
	} */
	.itemTitle {
		/* margin-top: 7px; */
		display: none;
	}
	
}

</style>
